var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uh-header"},[_c('a',{attrs:{"href":"https://www.umpshealth.com"}},[_c('img',{staticStyle:{"height":"45px","vertical-align":"middle","margin-bottom":"0.9em"},attrs:{"src":"dist/uhlogo.png","alt":"Umps Health"}})]),_vm._v(" "),_c('p',{staticClass:"text-muted",staticStyle:{"display":"inline-block","font-size":"30px"}},[_vm._v("Portal")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21a052d2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 28
// module chunks = 0